import React from "react";
import HeaderComponent from "@components/common/Header/Header";
import DocumentIcon from "@styles/all-images/images/main-content-image.png";
import BackIcon from "@styles/all-images/icons/back-button.svg";

const ApprovedOnBoardingDocumentShow: React.FC = () => {
  return (
    <div className="tw-relative">
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-pt-4 tw-pb-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/approved-on-boarding-document">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Financial Statement Year 1 (Unaudited)
              </h1>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px] tw-gap-6 tw-flex-col tw-flex">
        <div className="tw-flex tw-items-start tw-gap-6">
          <div className="tw-w-[20%] tw-flex tw-flex-col tw-gap-6">
            <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-full">
              <div className="tw-flex tw-justify-between tw-items-center tw-px-6 tw-py-4">
                <h2 className="tw-text-base tw-font-semibold tw-text-[#232323]">
                  SOP
                </h2>
              </div>
              <hr />
              <div className="tw-px-6 tw-py-4 tw-ml-5">
                <ul>
                  <li className="tw-text-[#232323] tw-text-sm tw-font-medium tw-list-disc tw-mb-2">
                    Directors Checked on CIPC?
                  </li>
                  <li className="tw-text-[#232323] tw-text-sm tw-font-medium tw-list-disc tw-mb-2">
                    Financial Year End Accurately Entered?
                  </li>
                </ul>
              </div>
            </div>
            <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-full">
              <div className="tw-px-6 tw-py-4">
                <span className="tw-text-[#232323] tw-text-xs tw-font-medium">
                  Rejected by
                </span>
                <h2 className="tw-text-[#146C94] tw-text-sm tw-font-semibold tw-mt-1">
                  Elijah Adebayo
                </h2>
              </div>
              <hr />
              <div className="tw-px-6 tw-flex tw-flex-col tw-gap-2 tw-py-4">
                <span className="tw-text-[#232323] tw-text-xs tw-font-medium">
                  Reason
                </span>
                <p className="tw-text-[#232323] tw-text-sm tw-font-medium">
                  The document has been rejected because the directors' details
                  have not been verified against the CIPC records, and the
                  financial year-end has either been incorrectly entered or does
                  not align with the registered details.
                </p>
                <span className="tw-text-[#809199] tw-text-xs tw-font-medium">
                  Oct 28, 11:22 AM
                </span>
              </div>
            </div>
          </div>

          <div className="tw-w-[60%] tw-flex tw-flex-col tw-gap-6">
            <img src={DocumentIcon} alt="File Icon" />
          </div>
          <div className="tw-w-[20%]"></div>
        </div>
      </div>
    </div>
  );
};

export default ApprovedOnBoardingDocumentShow;
